import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import { updateProfile } from '@cinch/oxd-redux/profile/src/actions'
import { getDelivery } from '@cinch/oxd-redux/profile/src/selectors'

import DeliveryPreference from '@cinch/oxd-components/delivery-preference/src'

export enum DELIVERY_OPTION {
  DEALERSHIP = 'DealershipOnly',
  DELIVERY = 'DeliveryOnly',
}

export const mapStateToProps = (state: any) => {
  const delivery = getDelivery(state)

  return { isSelected: delivery === DELIVERY_OPTION.DELIVERY }
}

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  onChange: (isSelected: boolean) => {
    const value = isSelected ? DELIVERY_OPTION.DELIVERY : DELIVERY_OPTION.DEALERSHIP
    dispatch(updateProfile({ deliveryOption: value }))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryPreference)
